import React from 'react';
import Products from './Products';
import './ProductsPage.css';

const ProductsPage = ({ onBack }) => {
  return (
    <div className="products-page">
      <div className="page-hero">
        <div className="container">
          <h1 className="page-hero-title">Ürünlerimiz</h1>
          <p className="page-hero-subtitle">
            Bulut Ambalaj olarak çeşitli boyut ve tasarım seçenekleriyle karton bardak üretimi yapıyoruz.
          </p>
        </div>
      </div>
      <Products showAll={true} />
    </div>
  );
};

export default ProductsPage;
